import { ArrowRightIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

import { Logo } from '@/components/Logo';

export default function Header() {
  return (
    <header className="relative h-0">
      <article className="absolute inset-x-0 top-0 z-10 flex justify-center border-b border-white/10 bg-emerald-50/5 shadow-sm backdrop-blur-sm">
        <nav
          className="flex h-fit w-full max-w-5xl flex-row items-center justify-between px-4 py-2 2xl:px-0"
          aria-label="Global"
        >
          <ul className="flex items-center space-x-8 text-sm font-medium">
            <li>
              <a href="/">
                <span className="sr-only">RAS</span>
                <Logo className="h-12 w-auto select-none" />
              </a>
            </li>
            {/* <li>
            <a href="/" className="text-zinc-200 hover:text-white">
              Services
            </a>
          </li> */}
            {/* <li className="">
            <a
              href="https://www.handicapper.net/college-basketball-picks.php"
              className="text-zinc-200 hover:text-white"
            >
              Results
            </a>
          </li>{' '} */}
          </ul>
          <ul className="flex items-baseline justify-end space-x-8">
            <li className="hidden border-r border-white/50 pr-8 md:inline-block">
              <a href="/order" className="text-sm font-semibold text-white hover:text-zinc-200">
                Order
              </a>
            </li>
            <li>
              <a href="/signin" className="text-sm font-semibold text-white hover:text-zinc-200">
                Sign in
              </a>
            </li>
            <li className="hidden sm:inline-block">
              <a
                className="group inline-flex justify-center space-x-0.5 overflow-hidden rounded bg-white/10 p-2 px-6 text-sm font-medium text-white ring-1 ring-inset ring-white/20 transition hover:bg-white/20 hover:text-white hover:ring-white/30"
                href="/register"
              >
                <span>Get free picks</span>
                <ChevronRightIcon className="h-5 w-5 group-hover:hidden" />
                <ArrowRightIcon className="hidden h-5 w-5 p-px transition-transform group-hover:block" />
              </a>
            </li>
          </ul>
        </nav>
      </article>
    </header>
  );
}
